export const MEDICAL_STUDENT_REGISTRATION_ROLE =
  'MEDICAL_STUDENT_ANESTHESIOLOGY';
export const MEDICAL_STUDENT_ROLE_LABEL =
  'Medical student pursuing anesthesiology';
export const MEDICAL_STUDENT_TRAINING_STAGE = 'MEDICAL_STUDENT';

export function registrationRoleFromDraft(draft) {
  return draft?.registrationRole || draft?.providerType || 'CRNA';
}

export function isMedicalStudentRegistrationRole(role) {
  return role === MEDICAL_STUDENT_REGISTRATION_ROLE;
}

export function isMedicalStudentRegistrationDraft(draft) {
  return isMedicalStudentRegistrationRole(registrationRoleFromDraft(draft));
}

export function providerTrainingStage(user) {
  return user?.providerProfile?.trainingStage || user?.trainingStage || null;
}

export function isMedicalStudentProvider(user) {
  return providerTrainingStage(user) === MEDICAL_STUDENT_TRAINING_STAGE;
}

export function stageFirstProviderLabel(providerType, trainingStage) {
  return trainingStage === MEDICAL_STUDENT_TRAINING_STAGE
    ? MEDICAL_STUDENT_ROLE_LABEL
    : providerType;
}

export function registrationIdentityForRole(role) {
  if (isMedicalStudentRegistrationRole(role)) {
    return {
      providerType: 'Anesthesiologist',
      userType: 'MEDICAL_STUDENT',
      trainingStage: MEDICAL_STUDENT_TRAINING_STAGE,
    };
  }
  if (role === 'SRNA') {
    return { providerType: 'CRNA', userType: 'SRNA', trainingStage: null };
  }
  return { providerType: role || 'CRNA', userType: 'PROVIDER', trainingStage: null };
}
